import { Link } from 'react-router-dom';
import { SalesInvoiceDetail, SalesInvoiceDetailFilters } from '../../../../app/models/SalesInvoiceDetail';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import SalesInvoiceFilter from './SalesInvoiceFilter';
import { PaymentStatusDataForm, PaymentStatusesStatus } from '../../../../app/models/PaymentStatus';
import PaymentStatusChangeStatus from '../../../PaymentStatus/components/PaymentStatusChangeStatus';

interface Props {
    salesInvoiceDetail: PaymentStatusDataForm[];
    totalRows: number;
    loading?: boolean;
    filter: SalesInvoiceDetailFilters;
    setFilter: (filter: SalesInvoiceDetailFilters) => void;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    callbackSuccess: () => void;
    statuses: PaymentStatusesStatus[];

}

const SalesInvoiceDetailDataTable = ({
    salesInvoiceDetail,
    totalRows,
    loading = false,
    filter,
    setFilter,
    edit,
    destroy,
    show,
    callbackSuccess,
    statuses,
}: Props) => {

    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    };

    const columns = [
        {
            name: 'Pos',
            selector: (row: any) => row.position,
            sortable: true,
            sortField: 'position',
            width: '80px',
            cell: (row: any) => <span>{row.position}</span>
        },
        {
            name: 'Entrega',
            selector: (row: any) => row.delivery_number,
            sortable: true,
            sortField: 'delivery_number',
            width: '120px',
            cell: (row: any) =>
                row.delivery_id ? (
                    <Link
                        to={`/deliveries/${row.delivery_id}/view`}
                        className="text-primary text-decoration-underline"
                    >
                        {row.delivery_number || `#${row.delivery_id}`}
                    </Link>
                ) : (
                    <span className="text-muted">-</span>
                )
        },
        {
            name: 'Glosa',
            selector: (row: any) => row.product_sale_name || row.product_name,
            sortable: true,
            sortField: 'product_sale_name',
            cell: (row: any) => (
                <span><strong>{row.product_sale_name || row.product_name || `Detalle #${row.id}`}</strong></span>
            )
        },
        {
            name: 'Cantidad',
            selector: (row: any) => row.quantity,
            sortable: true,
            sortField: 'quantity',
            width: '120px',
            cell: (row: any) => (
                <span>{row.quantity ? `${row.quantity} ${row.unit_name || ''}` : '-'}</span>
            )
        },
        {
            name: 'Valor Unitario',
            selector: (row: any) => row.unit_value,
            sortable: true,
            sortField: 'unit_value',
            width: '130px',
            right: true,
            cell: (row: any) => <span>{formatCurrency(row.unit_value || 0)}</span>
        },
        {
            name: 'Neto',
            selector: (row: any) => row.neto,
            sortable: true,
            sortField: 'neto',
            width: '130px',
            right: true,
            cell: (row: any) => <span>{formatCurrency(row.neto || 0)}</span>
        },
        {
            name: 'Impuesto',
            selector: (row: any) => row.tax,
            sortable: true,
            sortField: 'tax',
            width: '130px',
            right: true,
            cell: (row: any) => <span>{formatCurrency(row.tax || 0)}</span>
        },
        {
            name: 'Total',
            selector: (row: any) => row.total,
            sortable: true,
            sortField: 'total',
            width: '150px',
            right: true,
            cell: (row: any) => <span><strong>{formatCurrency(row.total || 0)}</strong></span>
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            width: '100px',
            cell: (row: any) => (
                <div>
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            {/* <div className="row mt-3">
                <div className="col">
                    <SalesInvoiceFilter filter={filter} setFilter={setFilter} />
                </div>
            </div> */}

            <DefaultDataTable
                columns={columns}
                data={salesInvoiceDetail}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default SalesInvoiceDetailDataTable;
